export const digitsMask = (value: string) =>
  value
    .replace(/\D/g, '')
    .split('')
    .map(() => /\d/)
